import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';

import connectToStores from '../../helpers/connectToStores';
import OrderStore from '../../stores/OrderStore';
import OrderActions from '../../actions/OrderActions';
import OrderHandoff from '../../records/order/Handoff';
import Order from '../../records/Order';
import config from '../../config';
import t from '../../lib/I18n';

const _getStateFromStores = () => ({
    handoffDetails: OrderStore.getHandoffDetails(),
});

class NRETransactionFrame extends Component {
    componentWillUnmount() {
        _.defer(() => OrderActions.updateHandoffDetails(null));
    }

    render() {
        const { handoffDetails, order } = this.props;

        if (!handoffDetails || !handoffDetails.handoffid) {
            return null;
        }

        const isProd = config.get('environment') === 'prod';
        const baseUrl = config.get(isProd ? 'journeyPlannerNREUrl' : 'journeyPlannerNREStagingUrl');
        const queryString = `?${handoffDetails.getTransactionQueryString(order.id)}`;
        const url = `${baseUrl}/service/iframe/success${queryString}`;

        return (
            <iframe title={t('ariaLabel.iframe.nreTransaction')} src={url} width={1} height={1} frameBorder={0} style={{ display: 'none' }} />
        );
    }
}

NRETransactionFrame.propTypes = {
    handoffDetails: PropTypes.instanceOf(OrderHandoff),
    order: PropTypes.instanceOf(Order),
};

export default connectToStores([OrderStore], _getStateFromStores)(NRETransactionFrame);
